import { AspectRatioType } from '../../utils';

export type GenerateSrcOptionsType = {
  width: number;
  height: number;
  url: string;
  aspectRatio: AspectRatioType;
  hasDarkeningLayer?: boolean;
  hasImageTransparency?: boolean;
  additionalUrlParameters?: Record<string, string>;
  omitAspectRatioInUrl?: boolean;
};

const presets = {
  default: {
    opaque: '$smartResponsiveHiDPI$',
    transparent: '$smartResponsiveAlpha8$',
    darken: '$smartResponsiveDarkenHiDPI$'
  },
  xHiDPI: {
    opaque: '$smartResponsiveXHiDPI$',
    darken: '$smartResponsiveDarkenXHiDPI$'
  }
};

type ChoosePresetType = {
  width: number;
  hasDarkeningLayer?: boolean;
  hasImageTransparency?: boolean;
  aspectRatio: AspectRatioType;
};

const choosePreset = ({ width, hasDarkeningLayer, hasImageTransparency, aspectRatio }: ChoosePresetType) => {
  if (aspectRatio === 'none') {
    return '';
  }

  if (hasImageTransparency) {
    return presets.default.transparent;
  }

  if (width > 1920) {
    if (hasDarkeningLayer) {
      return presets.xHiDPI.darken;
    }

    return presets.xHiDPI.opaque;
  }

  if (hasDarkeningLayer) {
    return presets.default.darken;
  }

  return presets.default.opaque;
};

export const generateSrc = (options: GenerateSrcOptionsType): string => {
  const {
    width,
    url,
    height,
    aspectRatio,
    hasDarkeningLayer,
    hasImageTransparency,
    additionalUrlParameters,
    omitAspectRatioInUrl
  } = options;

  const params = new URLSearchParams({
    ...(aspectRatio === 'none' ? {} : { wid: Math.round(width).toString() }),
    hei: Math.round(height).toString(),
    ...additionalUrlParameters
  });

  const aspectRParam = aspectRatio === 'none' || omitAspectRatioInUrl ? '' : `:${aspectRatio}`;

  return `${url}${aspectRParam}?${choosePreset({
    aspectRatio,
    width,
    hasDarkeningLayer,
    hasImageTransparency
  })}&${params}`;
};
